import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWalkmanComponent } from './simple-icons-walkman.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWalkmanComponent ],
    exports:      [ SimpleIconsWalkmanComponent ],
    bootstrap:    []
})
export class SimpleIconsWalkmanModule {}
